const Exit = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="a">
          <rect width="18" height="18" fill="#fff" stroke="#707070" strokeWidth="1" />
        </clipPath>
      </defs>
      <g transform="translate(636 -4614)">
        <g transform="translate(-636 4614)">
          <path
            d="M12.49,13.019v1.329A2.66,2.66,0,0,1,9.833,17H3.157A2.66,2.66,0,0,1,.5,14.348V2.657A2.66,2.66,0,0,1,3.157,0H9.833A2.66,2.66,0,0,1,12.49,2.657V3.986a.664.664,0,0,1-1.329,0V2.657A1.33,1.33,0,0,0,9.833,1.329H3.157A1.33,1.33,0,0,0,1.829,2.657V14.348a1.33,1.33,0,0,0,1.329,1.329H9.833a1.33,1.33,0,0,0,1.329-1.329V13.019a.664.664,0,0,1,1.329,0Zm4.529-5.658L15.531,5.874a.664.664,0,0,0-.939.939L15.65,7.871H7.674a.664.664,0,1,0,0,1.329H15.65l-1.058,1.058a.664.664,0,1,0,.939.939L17.018,9.71a1.662,1.662,0,0,0,0-2.348Zm0,0"
            transform="translate(0.009 0.509)"
          />
        </g>
      </g>
    </svg>
  );
};

export default Exit;
